<template>
    <NuxtLayout name="default" mainClass="inside_main">
        <div class="privacy">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-12">
                    <div class="section_title">
                        <h1>
                            سياسة الخصوصية
                        </h1>
                    </div>
                </div>
            </div>

            <div class="privacy-inner">

                <template v-if="privacyPage">
                        <div v-html="privacyPage.content"></div>
                    </template>
                    <template v-else>
                        <p>جاري تحميل  سياسة الخصوصية ...</p>
                    </template>
                    
            </div>

        </div>
    </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
import { useWebsiteStore } from '~/store/website'
import { computed } from 'vue'

// استدعاء `websiteStore`
const websiteStore = useWebsiteStore()

// استخراج الصفحة التي تحمل `label === "privacy_policy"`
const privacyPage = computed(() => {
    return websiteStore.initializationData?.pages?.find(page => page.label === "privacy") || null;
})

useHead({
        title: 'سياسة الخصوصية',
        meta: [
        { property: 'og:title', content: ` سياسة الخصوصية | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
        { property: 'twitter:title', content: ` سياسة الخصوصية | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },       
        ]
    })
</script>
